import { useQuery } from '@tanstack/react-query'

import { CAR_STORY_QUERY_KEYS } from '../../lib'
import { type IGetMycleContentCategoriesParams } from '../../model'
import { getMycleContentCategories } from '../request'

const useMycleContentCategoriesQuery = ({
  menu,
}: IGetMycleContentCategoriesParams) =>
  useQuery({
    queryKey: CAR_STORY_QUERY_KEYS.CATEGORIES.list(menu),
    queryFn: () => getMycleContentCategories({ menu }),
    throwOnError: false,
  })

export default useMycleContentCategoriesQuery
